import { replace } from "react-router"
import type { LoaderFunctionArgs } from "react-router"

import type { Organization } from "@/models/organization"
import { RootPath } from "@/models/route"
import {
  buildPathWithResolvedOrgId,
  loadOrganizationResolutionContext,
} from "@/utils/organization/organization-loader-context"
import { resolveLoaderError } from "@/utils/route-loader-error"

export interface OrganizationIdLoaderData {
  organization: Organization | null
}

const normalizePathname = (pathname: string): string => {
  if (pathname.endsWith("/") && pathname.length > 1) {
    return pathname.slice(0, -1)
  }

  return pathname
}

const isOrganizationRootPath = (
  pathname: string,
  organizationId: string
): boolean => normalizePathname(pathname) === `/${organizationId}`

export const organizationIdLoader = async ({
  params,
  request,
}: LoaderFunctionArgs): Promise<OrganizationIdLoaderData | Response> => {
  const urlOrgId = params.orgId

  try {
    const context = await loadOrganizationResolutionContext(urlOrgId)

    if (!context?.resolvedOrganizationId) {
      return { organization: null }
    }

    const { resolvedOrganizationId, resolvedOrganization } = context
    const url = new URL(request.url)
    const pathname = buildPathWithResolvedOrgId(
      url.pathname,
      urlOrgId as string,
      resolvedOrganizationId
    )

    if (isOrganizationRootPath(pathname, resolvedOrganizationId)) {
      return replace(
        `/${resolvedOrganizationId}/${RootPath.Report}${url.search}`
      )
    }

    if (pathname !== url.pathname) {
      return replace(`${pathname}${url.search}`)
    }

    return { organization: resolvedOrganization }
  } catch (error: unknown) {
    return resolveLoaderError(error, request)
  }
}
